/**
 * Enterprise Repository DI Tokens
 * String literal tokens for registering and resolving repositories in the DI Container.
 */
export const REPOSITORY_TOKENS = {
  VISITOR: 'IVisitorRepository',
  DAILY_HELP: 'IDailyHelpRepository',
  STANDING_VEHICLE: 'IStandingVehicleRepository',
  UNIT: 'IUnitRepository',
  MEMBER: 'IMemberRepository',
  SOCIETY: 'ISocietyRepository',
  FINANCE: 'IFinanceRepository',
  LEDGER: 'ILedgerRepository',
  DUES: 'IDuesRepository',
  FACILITY: 'IFacilityRepository',
  HELPDESK: 'IHelpdeskRepository',
  SUGGESTION: 'ISuggestionRepository',
  COMMITTEE: 'ICommitteeRepository',
  COMPLIANCE: 'IComplianceRepository',
  NOTICE: 'INoticeRepository',
  COMMUNITY: 'ICommunityRepository',
  PROFILE: 'IProfileRepository',
  MATRIMONIAL: 'IMatrimonialRepository',
  DASHBOARD: 'IDashboardRepository',
  VENDOR: 'IVendorRepository',
  UPLOAD: 'IUploadRepository',
  SUBSCRIPTION: 'ISubscriptionRepository',
  SETTINGS: 'ISettingsRepository',
  AUTH: 'IAuthRepository',
  CALENDAR: 'ICalendarRepository',
} as const;

export type RepositoryToken = typeof REPOSITORY_TOKENS[keyof typeof REPOSITORY_TOKENS];
